import React from 'react';
import { RouteObject, redirect } from 'react-router-dom';

import { Login, OtpVerify } from 'features';

import PATHS from '../paths';
import ProtectedRoute from '../ProtectedRoute';

const authRoutes: RouteObject = {
  path: PATHS.auth,
  children: [
    {
      index: true,
      loader: () => {
        return redirect(PATHS.login);
      },
    },
    {
      path: PATHS.loginKey,
      element: (
        <ProtectedRoute from="authUser">
          <Login />
        </ProtectedRoute>
      ),
    },
    {
      path: PATHS.otpVerifyKey,
      element: (
        <ProtectedRoute from="authUser">
          <OtpVerify />
        </ProtectedRoute>
      ),
    },
  ],
};

export default authRoutes;
